
import { RutaLocal } from '../componentes/funcionesEspeciales';
function MenuPrincipal({ cantidad, precio }) {

    return (<>
        <div className="stickymenu" style={{zIndex: 9998}}>
            <div id="stickyCartHeader" className="">
                <div className="row align-items-center bottom-header-bar">
                    <div className="col col-md-7 col-lg-5 col-xl-5 mainmenu-navbar">
                        <ul className="go-variant1-content-exp1 Secondary">
                            <li id="menuoverview">
                                <a href={RutaLocal + "menuPollos"} >
                                    CARTA
                                </a>
                            </li>
                            <li>
                                <a href={RutaLocal + "menuPromociones"} >
                                    COMBOS
                                </a>
                            </li>
                            <li>
                                <a href={RutaLocal + "buscaFactura"} >
                                    BUSCA TU FACTURA
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-5 col-lg-7 col-xl-7 col-auto bg-white-class isrestaurentselected padding-left-0 d-flex justify-content-end">
                        <a href={RutaLocal + "carrito"} className="shopping-cart d-md-down d-flex gap-4 align-items-center ms-3" style={{minWidth: '45px'}}>
                            <div className="cart-counter empty d-flex gap-2 align-items-center justify-content-center">
                                <p className="cart-qty-size text-white h6 national-bold text-danger position-absolute" id="cartHeaderQty">
                                    {cantidad}
                                </p>
                                <div className=''>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#fff" className="bi bi-cart-fill" viewBox="0 0 16 16">
                                        <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                                    </svg>
                                </div>
                            </div>
                            <p className="price text-white h6 national-bold" id="cartHeaderPrice">
                                S/ <strong>{parseFloat(precio).toFixed(2)}</strong>
                            </p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default MenuPrincipal;